"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const interface_1 = require("../interface");
const list_menu_1 = require("../list-menu");
const styled_1 = require("./styled");
const ListActions = props => {
    const { children, dataTestId, itemsVisibleOnMobile = 1, itemsVisibleOnDesktop = 3 } = props;
    const actions = react_1.Children.toArray(children).filter(child => (0, react_1.isValidElement)(child));
    const actionsAmount = actions.length;
    const isSmallScreen = (0, material_1.useMediaQuery)(theme => theme.breakpoints.down("sm"));
    const itemsQuantity = isSmallScreen ? itemsVisibleOnMobile : itemsVisibleOnDesktop;
    const renderActions = () => {
        if (actionsAmount > itemsQuantity) {
            const visibleActions = react_1.Children.map(actions.slice(0, itemsQuantity - 1), action => (0, react_1.cloneElement)(action, { variant: interface_1.ListActionVariant.iconButton }));
            const hiddenActions = react_1.Children.map(actions.slice(itemsQuantity - 1), action => (0, react_1.cloneElement)(action, { variant: interface_1.ListActionVariant.menuItem }));
            const isAllHiddenActionsDisabled = hiddenActions.every(action => action.props.disabled);
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [visibleActions, (0, jsx_runtime_1.jsx)(list_menu_1.ListMenu, { disabled: isAllHiddenActionsDisabled, dataTestId: dataTestId, children: hiddenActions })] }));
        }
        return actions;
    };
    if (actionsAmount === 0) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(styled_1.Root, { children: renderActions() });
};
exports.ListActions = ListActions;
//# sourceMappingURL=index.js.map